module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00734.3340a06a.jpg";